<script type="text/javascript">
  // REVINRE site review
  export default {
    props: ['website'],
    data() {
      return {
        title: 'REVINRE',
        url: 'https://revinre.com',
        updated: '9/18/2023',

        pages: [
          // ========== START OF PAGE ==========
          {
            title: 'Home',
            main: 1,
            url: 'https://revinre.com',
            positives: [
              '',
            ],
            negatives: [
              'H2 tags have issues. The packages section should only have one H2 tag being the title for the section.',
            ],
            meta_title: 'Revolution in Real Estate. | REVINRE	',
            meta_desc: 'From free to full service and everything in between we are here to help you sell your home and save you thousands. We also offer buyer, mortgage, insurance and title services to cover any aspect of the home buying/selling process.',
            h1: [
              'Sell your home and save thousands',
            ],
            h2: [
              'Why list with REVINRE over a traditional agent?',
              'Our packages and services',
              'Basic',
              '$0',
              'Premium',
              '$499',
              'Elite',
              '$1,999',
              'A La Carte services',
              'Calculate your savings',
              'What our clients say',
              'The listing process',
              'How would you like to list your property?',
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Sell',
            main: 1,
            url: 'https://revinre.com/selling',
            positives: [
              '',
            ],
            negatives: [
              '',
            ],
            meta_title: 'List Your Home For Free In AZ | REVINRE',
            meta_desc: 'Get your home listed on the MLS. Pick and choose only the services you need from free all the way up to a full service agent. Keep your equity by cutting out unnecessary listing commissions.',
            h1: [
              'List your property for free',
            ],
            h2: [
              'How would you like to list your property?',
              'The listing process',
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Buy',
            main: 1,
            url: 'https://revinre.com/listings',
            positives: [
              '',
            ],
            negatives: [
              '',
            ],
            meta_title: 'Homes For Sale & Real Estate Listings In AZ | REVINRE',
            meta_desc: `Search local homes and land for sale in Arizona and New York. Find your dream home today or get in touch with our experienced agents to help find exactly what you're looking for.`,
            h1: [
              'Homes for sale in AZ',
            ],
            h2: [
              '',
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Home valuation',
            main: 1,
            url: 'https://revinre.com/valuation',
            positives: [
              '',
            ],
            negatives: [
              '',
            ],
            meta_title: `What's your home worth? | REVINRE`,
            meta_desc: 'Get your free automated home valuation. For a more comprehensive valuation you can request a CMA from one of our experienced brokers.',
            h1: [
              `What's your home worth?`,
            ],
            h2: [
              '',
              '',
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'How it works',
            main: 1,
            url: 'https://revinre.com/how-it-works',
            positives: [
              '',
            ],
            negatives: [
              '',
            ],
            meta_title: 'Selling Your Home Has Never Been Eaiser | REVINRE',
            meta_desc: 'Our goal at REVINRE is to bring the home selling and buying process into the 21st century using the technologies available today. By providing customers with the ability to select only the services that really made a difference in todays market saving thousands in commissions costs.',
            h1: [
              'How it works',
            ],
            h2: [
              'About us',
              'Why choose us?',
              'How would you like to list your property?',
              'The listing process',
              'Our packages and services',
              'Basic',
              '$0',
              'Premium',
              '$499',
              'Elite',
              '$1,999',
              'A La Carte services',
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Preferred partners (REVINRE ONLY)',
            main: 1,
            url: 'https://revinre.com/partners',
            positives: [
              '',
            ],
            negatives: [
              '',
            ],
            meta_title: 'We cover every aspect of the home buying/selling process In AZ | REVINRE',
            meta_desc: 'We offer seller, buyer, mortgage, insurance and title services to cover any aspect of the home buying/selling process. Through our preferred vendors we also provide recommendations for moving services, cleaning services, new construction, home renovation and much more.',
            h1: [
              'Preferred partners',
            ],
            h2: [
              'Hunt Mortgage',
              'HOW MUCH CAN I SPEND ON A HOUSE?',
              'Hunt Insurance',
              'HUNT INSURANCE HAS YOU COVERED. ',
              'Hunt Title',
              'NETWORK TITLE TAKES CARE OF THE PAPERWORK.',
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Blog',
            main: 1,
            url: 'https://revinre.com/blog',
            positives: [
              '',
            ],
            negatives: [
              '',
            ],
            meta_title: 'All You Need to Know About Buying Or Selling A Home | REVINRE',
            meta_desc: 'Whether you are selling, buying, building or renovating a home we are here to provide the most current information and recommendations to get the most out of your home.',
            h1: [
              'Blog',
              'Do I really need professional photos?',
              'Arizona Housing Market Update September 2020',
              'Arizona Housing Market Update August 2020',
              '5 Tips for Selling your Home during COVID-19',
              'Blog',
            ],
            h2: [
              'Do I really need professional photos?',
              'Arizona Housing Market Update September 2020',
              'Arizona Housing Market Update August 2020',
              '5 Tips for Selling your Home during COVID-19',
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'More',
            main: 1,
            children: [
              // ========== START OF PAGE ==========
              {
                title: 'Testimonials',
                main: 1,
                url: 'https://revinre.com/testimonials',
                positives: [
                  '',
                ],
                negatives: [
                  '',
                ],
                meta_title: 'Revinre Testimonals And Reviews | REVINRE',
                meta_desc: 'We are proud to say that our clients have rated us 4.9 on Google and Facebook. Read what our clients have said about us.',
                h1: [
                  'Testimonials',
                ],
                h2: [
                  'What our clients say',
                  'Videos',
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'FAQ',
                main: 1,
                url: 'https://revinre.com/faq',
                positives: [
                  '',
                ],
                negatives: [
                  '',
                ],
                meta_title: 'All You Need to Know About Buying Or Selling A Home With REVINRE | REVINRE',
                meta_desc: 'We are constantly trying to simplify the home selling and buying process, as part of this initiative we work hard to provide answers to any frequently asked questions.',
                h1: [
                  'FAQ',
                ],
                h2: [
                  `Do I need to offer a buying commission? If so, what should I offer?`,
                  `What is an EA listing agreement?`,
                  `Can I list my property for free?`,
                  `How does contract to close work?`,
                  `What is the benefit of working with REVINRE partners?`,
                  `Your services are not offered in my area.`,
                  `Value of packages and services.`,
                  `Is professional photography worth it?`,
                  `How do I list my property`,
                  `Can I start with the free service and upgrade if needed?`,
                  `How does the listing process work?`,
                  `Account login`,
                  `Account other issues`,
                  `Account registration`,
                  `Account change email address`,
                  `Account forgot password`,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Contact us',
                main: 1,
                url: 'https://revinre.com/contact',
                positives: [
                  '',
                ],
                negatives: [
                  '',
                ],
                meta_title: 'We Are Here To Help | REVINRE',
                meta_desc: 'Our goal is to simplify every part of the home selling and home buying process, which includes answering any questions or concerns. Please do not hesitate to contact with any questions or concerns you may have.',
                h1: [
                  'Contact us',
                ],
                h2: [
                  'Get in touch',
                ]
              },
            ],
          },
          // ========== START OF PAGE ==========
          {
            title: 'My account',
            main: 1,
            children: [
              // ========== START OF PAGE ==========
              {
                title: 'Login',
                main: 1,
                url: 'https://revinre.com/login',
                positives: [
                  '',
                ],
                negatives: [
                  '',
                ],
                meta_title: 'Get Your Home Listed In AZ | REVINRE',
                meta_desc: 'From free to full service and everything in between we are here to help you sell your home and save you thousands. We also offer buyer, mortgage, insurance and title services to cover any aspect of the home buying/selling process.',
                h1: [
                  'List your property for free',
                ],
                h2: [
                  'Login',
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Register',
                main: 1,
                url: 'https://revinre.com/register',
                positives: [
                  '',
                ],
                negatives: [
                  '',
                ],
                meta_title: 'Get Your Home Listed In AZ | REVINRE',
                meta_desc: 'From free to full service and everything in between we are here to help you sell your home and save you thousands. We also offer buyer, mortgage, insurance and title services to cover any aspect of the home buying/selling process.',
                h1: [
                  'List your property for free',
                ],
                h2: [
                  'Register',
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'My profile (Logged in only)',
                main: 1,
                url: 'https://revinre.com/my-profile',
                positives: [
                  '',
                ],
                negatives: [
                  '',
                ],
                meta_title: 'Get Your Home Listed In AZ | REVINRE',
                meta_desc: 'From free to full service and everything in between we are here to help you sell your home and save you thousands. We also offer buyer, mortgage, insurance and title services to cover any aspect of the home buying/selling process.',
                h1: [
                  'My profile',
                ],
                h2: [
                  '',
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'My listings (Logged in only)',
                main: 1,
                url: 'https://revinre.com/my-listings',
                positives: [
                  '',
                ],
                negatives: [
                  '',
                ],
                meta_title: 'List Your Home For Free In AZ | REVINRE',
                meta_desc: 'Get your home listed on the MLS. Pick and choose only the services you need from free all the way up to a full service agent. Keep your equity by cutting out unnecessary listing commissions.',
                h1: [
                  'Manage your listings',
                ],
                h2: [
                  'My listings',
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'My favorites (Logged in only)',
                main: 1,
                url: 'https://revinre.com/my-favorites',
                positives: [
                  '',
                ],
                negatives: [
                  '',
                ],
                meta_title: 'Manage your favorite homes for sale | REVINRE',
                meta_desc: 'From free to full service and everything in between we are here to help you sell your home and save you thousands. We also offer buyer, mortgage, insurance and title services to cover any aspect of the home buying/selling process.',
                h1: [
                  'Manage your favorites',
                ],
                h2: [
                  'My favorites',
                ]
              },
            ],
          },
          // ========== START OF PAGE ==========
          {
            title: 'Buying',
            main: 0,
            url: 'https://revinre.com/buying',
            positives: [
              '',
            ],
            negatives: [
              '',
            ],
            meta_title: 'Homes For Sale & Real Estate Listings In AZ | REVINRE',
            meta_desc: `Search local homes and land for sale in Arizona and New York. Find your dream home today or get in touch with our experienced agents to help find exactly what you're looking for.`,
            h1: [
              'Find your dream home',
            ],
            h2: [
              '',
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Full service',
            main: 0,
            url: 'https://revinre.com/full-service',
            positives: [
              '',
            ],
            negatives: [
              '',
            ],
            meta_title: 'Full Service Real Estate Agents In AZ | REVINRE',
            meta_desc: `Get your home listed on the MLS. Pick and choose only the services you need from free all the way up to a full service agent. Keep your equity by cutting out unnecessary listing commissions.`,
            h1: [
              'Full service agents',
            ],
            h2: [
              'Get in touch with us',
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Privacy policy',
            main: 0,
            url: 'https://revinre.com/privacy',
            positives: [
              '',
            ],
            negatives: [
              '',
            ],
            meta_title: 'Get Your Home Listed In AZ | REVINRE',
            meta_desc: `From free to full service and everything in between we are here to help you sell your home and save you thousands. We also offer buyer, mortgage, insurance and title services to cover any aspect of the home buying/selling process.`,
            h1: [
              'List your property for free',
            ],
            h2: [
              `Our Privacy Policy`,
              `Collecting Information`,
              `Using Information Collected`,
              `Updating Information`,
              `Updating Our Privacy Policy`,
              `Contacting Us`,
              `Effective Date:`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Terms of service',
            main: 0,
            url: 'https://revinre.com/terms',
            positives: [
              '',
            ],
            negatives: [
              '',
            ],
            meta_title: 'Get Your Home Listed In AZ | REVINRE',
            meta_desc: `From free to full service and everything in between we are here to help you sell your home and save you thousands. We also offer buyer, mortgage, insurance and title services to cover any aspect of the home buying/selling process.`,
            h1: [
              'List your property for free',
            ],
            h2: [
              '',
            ]
          },
        ],


      }
    },
    computed: {
      compPages: function() {
        var output = [];
        for(var i in this.pages) {
          var temp = JSON.parse(JSON.stringify(this.pages[i]));
          if(temp['children']) { delete temp['children']; }
          output.push(temp);
          if(this.pages[i]['children']) {
            for(var j in this.pages[i]['children']) {
              var temp = JSON.parse(JSON.stringify(this.pages[i]['children'][j]));
              if(temp['children']) { delete temp['children']; }
              output.push(temp);
            }
          }
        }
        return output;
      },
    },
    created() {

    },
    methods: {

    }
  }
</script>

<template>
  <section>

    <w-site-navbar
      :website="website"
      :static="0"
    ></w-site-navbar>
    <main>

      <section class="bg-home pb-5">
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" style="background-image: url(https://s3.revinre.com/website/Development/background_09.jpg);"></div>
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 bg-black _o-5"></div>
        <div class="container-fluid pt-15 pb-10 m_py-35">
          <div class="row justify-content-center">
            <div class="col-lg-6">
              <div class="home-content text-center mb-4">
                <h1 class="home-title mb-3 text-white" data-aos="fade-zoom-in">Sell your home and save thousands</h1>
                <p class="text-white home-desc"  data-aos="fade-zoom-in">0% Listing fee | Average savings of $14,250 | 4.7 Star rating on Google</p>
                <div class="row mt-5">
                  <div class="col-sm px-sm-1"><a href="/selling" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-revinre aos-init">I'm selling</a></div>
                    <div class="col-sm px-sm-1"><a href="/buying" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">I'm buying</a></div>
                    <div class="col-sm px-sm-1"><a href="/valuation" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">Home valuation</a></div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section">
        <div class="container-fluid py-5">

          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:pantone-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3 text-" data-aos="fade-zoom-in">{{title}} navigation</h2>
            <p class="text-" data-aos="fade-zoom-in">Overview of {{title}}'s navigation menu, sub menu's and additional pages.</p>
          </div>

          <div class="border font-weight-bold rounded bg-lighten-success small p-5">
            <h4 class="_underline">Site info</h4>
            <div class="mb-5">
              <div class=""><strong>Company :</strong> {{title}}</div>
              <div class=""><strong>URL :</strong> {{url}}</div>
              <div class=""><strong>Last updated :</strong> {{updated}}</div>

            </div>
            <h4 class="_underline">Main navigation</h4>
            <ul class="pl-3 m-0">
              <li v-for="(item, item_i) in pages" :key="item_i" v-if="item['main']">
                <div class="font-weight-bolder">{{item['title']}}</div>
                <ul class="pl-5 m-0">
                  <li v-for="(sub1, sub1_i) in item['children']" :key="sub1_i">
                    {{sub1['title']}}
                    <ul class="pl-5 m-0">
                      <li v-for="(sub2, sub2_i) in sub1['children']" :key="sub2_i">
                        {{sub2['title']}}
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

            </ul>
            <h4 class="mt-5 _underline">Additional pages</h4>
            <ul class="pl-3 m-0">
              <li v-for="(item, item_i) in pages" :key="item_i" v-if="!item['main']">{{item['title']}}</li>
            </ul>
          </div>



        </div>
      </section>

      <section class="section">
        <div class="container-fluid py-5">

          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:pantone-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3 text-" data-aos="fade-zoom-in">{{title}} page content</h2>
            <p class="text-" data-aos="fade-zoom-in">Overview of {{title}}'s website content and SEO basics. Scroll through the table vertically and horizontally with the mouse wheel.</p>
          </div>

          <div class="table-responsive">
            <table class="table table-small table-bordered-right table-hover mb-0 text-nowrap border border-light">
              <thead class="bg-lighten-success">
                <tr>
                  <th class="font-weight-bold">Menu item</th>
                  <th class="font-weight-bold">URL</th>
                  <th class="font-weight-bold">Positives</th>
                  <th class="font-weight-bold">Negatives</th>
                  <th class="font-weight-bold">Meta title</th>
                  <th class="font-weight-bold">Meta description</th>
                  <th class="font-weight-bold">H1's</th>
                  <th class="font-weight-bold">H2's</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_i) in compPages" :key="item_i">
                  <td class="bg-light font-weight-bold">{{item['title']}}</td>
                  <td>{{item['url']}}</td>
                  <td class="_w-n-400 _w-m-400 text-wrap">
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['positives']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                  <td class="_w-n-400 _w-m-400 text-wrap">
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['negatives']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                  <td>{{item['meta_title']}}</td>
                  <td class="_w-n-400 _w-m-400 text-wrap">{{item['meta_desc']}}</td>
                  <td>
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['h1']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['h2']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </section>

    </main>

    <w-site-footer
      :website="website"
    ></w-site-footer>

  </section>
</template>
